import styled from 'styled-components'
import { Grid, TGridMixin } from '../styles/mixins'
import { Container } from './Container'

export const GridContainer = styled(Container)<TGridMixin>`
  ${(props: TGridMixin) => Grid({ ...props })};
`
